
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"attribute.unknown.name":"Unbekanntes Attribut"},"en":{"attribute.unknown.name":"Unknown attribute"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();